import React, {Component} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import IconButton from "@irati/ui/src/Button/IconButton"
import deactivateUsersByCSV from "@irati/identity/utils/user/deactivateUsersByCSV"
import authentication from "@irati/auth"

import DeactivatePeopleCSV from "../../../components/Users/DeactivateUsers/DeactivatePeopleCSV/DeactivatePeopleCSV"
import SuccessWithBackLink from "../../../components/SuccessWithBackLink"
import {VIEW_PEOPLE} from "../../../routes/routeConfig"
import BackLink from "../../../components/Users/BackLink"

export enum DeactivatePeopleSteps {
  DEACTIVATE_PEOPLE_CSV = "deactivate_people-csv",
  DEACTIVATE_PEOPLE_SUCCESS = "deactivate_people-success"
}

interface Props extends InjectIntl {
  goBack: () => void
  alignLeft: boolean
}

interface FailedUser {
  email: string
  message: string
}

interface State {
  currentStep: DeactivatePeopleSteps
  csv: string[]
  isLoading: false
  load: Promise<any> | null
  failedUsers: FailedUser[]
  deactivatedUsers: number
}

class DeactivateMultiplePeople extends Component<Props, State> {
  state: State = {
    currentStep: DeactivatePeopleSteps.DEACTIVATE_PEOPLE_CSV,
    csv: [],
    isLoading: false,
    load: null,
    failedUsers: [],
    deactivatedUsers: 0
  }

  handleDrop = (acceptedFiles: any) => {
    const {formatMessage} = this.props
    this.setState({
      failedUsers: [],
      deactivatedUsers: 0
    })

    const load = deactivateUsersByCSV(acceptedFiles[0], formatMessage, authentication.business().uuid).then(
      ({failedUsers, deactivatedUsers}) => {
        this.setState({
          failedUsers,
          deactivatedUsers,
          currentStep: DeactivatePeopleSteps.DEACTIVATE_PEOPLE_SUCCESS
        })
      }
    )
    this.setState({load})
  }

  render() {
    const {currentStep, load, deactivatedUsers, failedUsers} = this.state
    const {goBack, formatMessage, alignLeft} = this.props

    return (
      <>
        {goBack ? <IconButton onClick={goBack} icon="backArrow" /> : <BackLink />}
        {currentStep === DeactivatePeopleSteps.DEACTIVATE_PEOPLE_CSV && (
          <DeactivatePeopleCSV alignLeft={alignLeft} back={goBack} load={load} onDrop={this.handleDrop} />
        )}
        {currentStep === DeactivatePeopleSteps.DEACTIVATE_PEOPLE_SUCCESS && (
          <SuccessWithBackLink
            message={formatMessage({id: "admin.components.deactivatePeopleCSV.deactivated"}, {uploadedCount: deactivatedUsers})}
            backLink={VIEW_PEOPLE}
            failedUsers={failedUsers}
            failedMessage="admin.components.deactivatePeopleCSV.failedUsers"
          />
        )}
      </>
    )
  }
}

export default injectIntl(DeactivateMultiplePeople)
